import styled, {css} from 'styled-components';

import {
  DatePicker as BaseDatePicker,
  InfoDropdown as BaseInfoDropdown,
  PeriodPicker as BasePeriodPicker,
} from '@edna/components';
import {Overlay} from '@edna/components/PeriodPicker/style';
import {mixins} from '@edna/components/styles';

export const Board = styled.div`
  width: 100%;
  ${({theme}) => css`
    margin: ${theme.spacing.s4} 0;
    padding: ${theme.spacing.s4};
    border: 1px solid ${theme.palette.grey200};
    border-radius: ${theme.borderRadius.br2};
  `}
`;

export const BoardFilters = styled.div`
  display: grid;
  grid-template-columns: 0.4fr 0.4fr 1fr;
  column-gap: ${({theme}) => theme.spacing.s6};
  align-items: end;
`;

export const BoardChips = styled.div`
  display: grid;
  grid-auto-columns: 1fr;
  grid-auto-flow: column;
  column-gap: ${({theme}) => theme.spacing.s5};
`;

export const BoardChip = styled.div`
  ${mixins.stack({size: '2', direction: 'ROW'})}
  min-height: 100px;
  ${({theme}) => css`
    padding: ${theme.spacing.s2};
    box-shadow: ${theme.boxShadow.XS};
    border-radius: ${theme.borderRadius.br2};
  `}
`;

export const BoardChipIcon = styled.div<{color: TThemeColor}>`
  ${mixins.wh('24px')}
  ${mixins.stack({align: 'center', justify: 'center'})}
  flex-shrink: 0;
  margin-top: 2px;
  ${({theme, color}) => css`
    background-color: ${theme.palette[color]};
    color: ${color.startsWith('yellow') ? theme.palette.grey900 : theme.palette.white};
    border-radius: 50%;
  `}

  svg {
    ${mixins.wh('16px')}
  }
`;

export const InfoDropdown = styled(BaseInfoDropdown)`
  top: 3px;
`;

export const PeriodPicker = styled(BasePeriodPicker)`
  width: 100%;

  ${Overlay} {
    max-height: 152px;
    overflow-y: auto;
  }
`;

export const DatePicker = styled(BaseDatePicker)`
  width: 100%;
`;
